"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpsGET = void 0;
const https_1 = __importDefault(require("https"));
function httpsGET(rawURL) {
    return new Promise((resolve, reject) => {
        https_1.default
            .get(rawURL, (res) => {
            if (res.statusCode != 200) {
                reject("unhandled response status: " + res.statusCode);
            }
            let body = "";
            res.on("data", (chunk) => {
                body += chunk;
            });
            res.on("close", () => {
                reject("closed");
            });
            res.on("error", (err) => {
                reject("receive error: " + err);
            });
            res.on("end", () => {
                resolve(body);
            });
        })
            .on("error", (err) => {
            reject("connect error: " + err);
        });
    });
}
exports.httpsGET = httpsGET;
//# sourceMappingURL=http.js.map